import store from '../../../vue/store'
import { cloneDeep, filter, flatMap, forEach, keys, map, pickBy, uniq, values, first, isEmpty } from 'lodash-es'

export default {
  props: {
    variationGroup: {
      type: Object
    },
    defaultValue: {
      type: String
    },
    variationProductGroupCombos: {
      type: Object
    },
    currentVariationProductGroupCombo: {
      type: Array
    },
    forceDisplayAllValues: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.defaultValue
    }
  },
  computed: {
    // Group ids that has variationGroupDisplayPosition 2(FILTER) and 3(NONE)
    getExcludedVariationProductGroupIds () {
      return this.$store.getters.allVariations
        .filter(variation => variation.variationGroupDisplayPosition === 2 || variation.variationGroupDisplayPosition === 3)
        .map(variation => variation.variationGroupId)
    },
    getVariationEntriesOfThisGroupFromVariationGroupData () {
      const variationEntries = this.variationGroup.variations

      const variationEntriesMergedForStock = variationEntries.map(itm => ({
        ...this.getVariationEntriesOfThisGroup.find((item) => {
          return item.variationId === itm.variationId && item
        }),
        ...itm
      }))

      return filter(variationEntriesMergedForStock, (variation) => {
        return this.getVariationEntriesIdsOfThisGroup.includes(variation.variationId)
      }).sort((a, b) => parseInt(a.variationOrder) - parseInt(b.variationOrder))
    },
    getVariationEntriesIdsOfThisGroup () {
      const ids = []
      const availableVariationEntries = this.getVariationEntriesOfThisGroup
      forEach(availableVariationEntries, (variation) => {
        if (variation.variationGroupId === this.variationGroup.variationGroupId) {
          ids.push(variation.variationId)
        }
      })
      return ids
    },
    getVariationEntriesOfThisGroup () {
      return filter(
        uniq(flatMap(values(this.getMatchingVariationProductGroupCombos(this.getAllOtherVariationGroups, this.forceDisplayAllValues)))),
        (groupCombo) => groupCombo.variationGroupId === this.variationGroup.variationGroupId
      )
    },
    getAllOtherVariationGroups () {
      return filter(
        this.currentVariationProductGroupCombo,
        (combo) => this.getAllOtherVariationGroupIds.includes(combo.variationGroupId)
      )
    },
    getAllOtherVariationGroupIds () {
      return filter(
        this.getAllVariationGroupIds,
        (variationGroupId) => variationGroupId !== this.variationGroup.variationGroupId
      )
    },
    getAllVariationGroupIds () {
      return uniq(map(this.getAllVariationCombosFlat, (variationCombo) => variationCombo.variationGroupId))
    },
    getAllVariationCombosFlat () {
      return uniq(flatMap(values(this.variationProductGroupCombos)))
    },
    getSelectedText () {
      if (this.defaultValue) {
        return this.defaultValue
      }
      if (!this.selected) {
        return ''
      }
      const selected = this.variationGroup.variations.find(item => item.variationId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.variationName
    }
  },
  methods: {
    getMatchingVariationProductGroupCombos (otherVariationGroups, skipEqualCheck = false) {
      return pickBy(
        this.variationProductGroupCombos,
        (variationGroupCombo) => {
          return skipEqualCheck || this.areCombosEqual(otherVariationGroups, variationGroupCombo)
        }
      )
    },
    areCombosEqual (comboList, otherComboList) {
      let matchCount = 0
      const comboListIgnoredLength = comboList
        .filter(combo => this.getExcludedVariationProductGroupIds.includes(combo.variationGroupId))
        .length
      for (const otherCombo of otherComboList) {
        for (const combo of comboList) {
          if (
            this.getExcludedVariationProductGroupIds.includes(otherCombo.variationGroupId) &&
            this.getExcludedVariationProductGroupIds.includes(combo.variationGroupId)
          ) {
            continue
          }
          if (otherCombo.variationId === combo.variationId && otherCombo.variationGroupId === combo.variationGroupId) {
            matchCount += 1
          }
        }
      }
      return (matchCount === (comboList.length - comboListIgnoredLength))
    },
    getMatchingProductsByVariationValueId (variationValueId, otherVariationGroups = []) {
      const variationGroupId = this.variationGroup.variationGroupId
      const otherVariationGroupsFilter = cloneDeep(otherVariationGroups)
      const relatedVariationData = store.getters.getRelatedVariationData
      otherVariationGroupsFilter.push({
        variationGroupId,
        variationId: variationValueId
      })
      const matchingProductIds = keys(this.getMatchingVariationProductGroupCombos(otherVariationGroupsFilter))
      return filter(relatedVariationData, (variation) => {
        return matchingProductIds.includes(variation.product_id)
      })
    },
    navigateToProduct (variationValueId) {
      const categoryData = store.getters.getProductCategoryData
      let matchingProducts = this.getMatchingProductsByVariationValueId(variationValueId, this.getAllOtherVariationGroups)
      if (matchingProducts.length === 0) {
        matchingProducts = this.getMatchingProductsByVariationValueId(variationValueId)
      }

      if (isEmpty(categoryData)) {
        this.navigateToVendorProduct(matchingProducts)
        return
      }

      this.navigateToCategoryProduct(matchingProducts, categoryData)
    },
    navigateToCategoryProduct (matchingProducts, categoryData) {
      if (matchingProducts.length === 0) {
        return
      }
      const urlDataLang = this.$store.getters.config.url.lang
      const urlSuffix = this.$store.getters.config.url.suffix
      const productSlug = first(matchingProducts).slug
      const categoryUrl = `/${urlDataLang}${categoryData.slug}/${productSlug}${urlSuffix}`
      window.location.assign(categoryUrl)
    },
    navigateToVendorProduct (matchingProducts) {
      if (matchingProducts.length === 0) {
        return
      }
      const vendorUrl = first(matchingProducts).productUrl
      window.location.replace(vendorUrl)
    }
  }
}
